import type React from "react";

import type { FeelingAtHomeWidgetV2Dto } from "@/api/types";
import { Speedometer } from "@/components/Speedometer/Speedometer";
import { useTranslation } from "@/translations";

import { FahWidgetScoreReferenceLabel } from "./FahWidgetScoreReferenceLabel";

type FahWidgetSpeedometerProps = {
  data: FeelingAtHomeWidgetV2Dto;
};

export const FahWidgetSpeedometer = ({ data }: FahWidgetSpeedometerProps): React.ReactNode => {
  const { t } = useTranslation();

  const score = data.totalFeelingAtHomeScore ? data.totalFeelingAtHomeScore.rating / 10 : 0;
  const label = t("component.analytics-widget.common.aop-benchmark.label", {
    score: data.benchmarkFeelingAtHomeScore?.rating?.toFixed(1) ?? "-",
  });

  return (
    <div className="flex w-full flex-col items-center justify-self-center pt-4 xl:pt-6">
      <h2 className="text-center text-headline3 xl:text-headline2">
        {t("component.analytics-widget.fah.speedometer.title")}
      </h2>
      <div className="flex w-full flex-col items-center gap-8 p-4 xl:p-6">
        <div className="flex w-full flex-col items-center gap-4 md:max-w-[386px]">
          <Speedometer
            score={score}
            renderCurrentValue={(currScore) => (currScore ? (currScore * 10).toFixed(1) : undefined)}
          />
          <p className="text-center text-body">
            {label}
            <br />
            <span className="text-grey-700">{t("component.analytics-widget.fah.speedometer.description")}</span>
          </p>
        </div>
        <FahWidgetScoreReferenceLabel
          currValue={data.totalFeelingAtHomeScore?.rating ?? 0}
          referenceValue={data.lastFeelingAtHomeScore?.rating ?? 0}
        />
      </div>
    </div>
  );
};
